import React, { Component } from 'react';
import { Group, List, Cell, Button, CellButton, Link } from '@vkontakte/vkui';
import {vkTime} from "../services/_functions";
import {setRefund} from "../store/bills/actions";


export default class BillCell extends Component{

    openModal = () => {
        this.props.openModalFunc(this.props.fio, this.props.price, vkTime(this.props.date), this.props.refund, vkTime(this.props.refundDate), this.props.allRefunds);
        this.props.setRefundFunc(this.props.price - this.props.refund, this.props.id, this.props.vkId);
    };

	render(){
		const statusArr = [<div className="waiting">В ожидании</div>, <div className="payed">Оплачен</div>, <div className="returned">Возвращен</div>];
        const noAva = require('../../img/no-ava.png');
        const img = this.props.photo === null || this.props.photo === '' ? noAva : this.props.photo;

		return(
			<Cell className='bills_cell' onClick={ this.openModal }>
				<div className="bills_cell_flex">
					<div className="bills_cell_ava" style={{ backgroundImage: `url(${img})` }}/>
					<div className="bills_cell_mid">
						<div className="bills_cell_mid_title">{ this.props.fio }</div>
						<div className="bills_cell_mid_time">{ vkTime(this.props.date) }</div>
					</div>
					<div className="bills_cell_end">
						<div className="bills_cell_end_sum">{ this.props.price } ₽</div>
						<div className="bills_cell_end_status">{ statusArr[this.props.status] }</div>
					</div>
				</div>
			</Cell>
		)
	}
}


// WEBPACK FOOTER //
// ./src/js/components/BillCell.js